import React from 'react';
import { PageLeftItem } from "../../model/page";
import Moment from "react-moment";
import { TFunction } from "i18next";
import TemplateComponent, { TemplateComponentProps } from "../../containers/template_page/template_component/template_component";
import { API_CONFIG } from '../../config/api_config';
import { CoursePageAttributes } from "../../containers/course_page/course_page";
import { extraSmallLayout } from "../../utils/device";
import "./c26t_corso_left_item.scss";


export interface C26TCourseLeftItemData extends PageLeftItem {
    title?: string;
    backlink_url: string;
    backlink_text: string;
    ects: number;
    years: number;
    start_date: Date;
    place: string;
    subscribe_label?: string;
    subscribe_url?: string;
    contact_label?: string;
    contact_url?: string;
}

interface C26CourseLeftItemProps extends TemplateComponentProps<C26TCourseLeftItemData> {
    courseAttributes: CoursePageAttributes;
}

class C26TCourseLeftItem extends TemplateComponent<C26TCourseLeftItemData, C26CourseLeftItemProps> {

    static readonly ID: string = "course_summary";

    constructor(props: C26CourseLeftItemProps) {
        super(props);

        this.requireInternationalization = true;
    }


    internationalComponentRender(data: C26TCourseLeftItemData, t: TFunction): React.ReactElement {

        let textColorStyle = {};
        let buttonBackgroundStyle = {};
        if (this.props.courseAttributes.color_dipartimento) {
            textColorStyle = { color: this.props.courseAttributes.color_dipartimento };
            buttonBackgroundStyle = { backgroundColor: this.props.courseAttributes.color_dipartimento };
        }

        return <div className="c26t-course-left-item">
            {!extraSmallLayout() &&
                <a className="backlink" href={data.backlink_url ? data.backlink_url : API_CONFIG.CORSI_E_MASTER_PATH}>
                    <div className="backlink-button-container">
                        <div className="backlink-button">
                            ‹
                        </div>
                    </div>
                    <div className="backlink-label">{data.backlink_text}</div>
                </a>
            }
            {data.title &&
                <h1 className="course-name" style={textColorStyle}>{data.title}</h1>
            }
            <table>
                <tbody>
                    <tr>
                        <td>
                            <span className="number" style={textColorStyle}>{data.ects}</span>
                            <span className="table-text"> {t("C26 table text ECTS")}</span>
                        </td>
                        <td>
                            <span className="number" style={textColorStyle}>{data.years}</span>
                            <span className="table-text"> {t("C26 table text years")}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p className="table-text">{t("C26 table text start date")} </p>
                            <p className="date" style={textColorStyle}><Moment date={data.start_date} format="MMMM YYYY" /></p>
                        </td>
                        <td>
                            <p className="table-text">{t("C26 table text place")} </p>
                            <p className="place" style={textColorStyle}>{data.place}</p>
                        </td>
                    </tr>
                </tbody>
            </table>
            {data.subscribe_label && data.subscribe_url &&
                <div className="button-container">
                    <a id="cta_applyNow" className="button subscribe" style={buttonBackgroundStyle} href={data.subscribe_url}>
                        {data.subscribe_label}
                    </a>
                </div>
            }
            {data.contact_label && data.contact_url && !extraSmallLayout() &&
                <div className="button-container">
                    <a className="button contact" href={data.contact_url}>{data.contact_label}</a>
                </div>
            }
        </div>;
    }
}

export default C26TCourseLeftItem;
